import { render, staticRenderFns } from "./UserGroup.vue?vue&type=template&id=38be6a6e&"
import script from "./UserGroup.vue?vue&type=script&lang=js&"
export * from "./UserGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38be6a6e')) {
      api.createRecord('38be6a6e', component.options)
    } else {
      api.reload('38be6a6e', component.options)
    }
    module.hot.accept("./UserGroup.vue?vue&type=template&id=38be6a6e&", function () {
      api.rerender('38be6a6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/UserGroup.vue"
export default component.exports